import { Select, Typography } from "antd";
import PersonIcon from "@/assets/icons/person.svg?react";
import { getAvatarColor, getInitials } from "@/utils/avatarUtils";

type LocalAssigneeSelectProps = {
  value?: string | number | boolean | null;
  options: string[];
  onChange: (nextValue: string | null) => void;
  compact?: boolean;
};

export default function LocalAssigneeSelect({
  value,
  options,
  onChange,
  compact = false,
}: LocalAssigneeSelectProps) {
  const renderAssigneeOption = (label: string) => {
    const text = label.length > 1 ? label : "Unassigned";

    return (
      <div className="grid grid-cols-[28px_1fr] items-center gap-2">
        <div
          className="w-7 h-7 rounded-full flex items-center justify-center text-white text-xs"
          style={{
            backgroundColor:
              text === "Unassigned" ? "#D5DADC" : getAvatarColor(text),
          }}
        >
          {text === "Unassigned" ? (
            <PersonIcon
              style={{ width: "20px", height: "20px" }}
              className="text-[#556C75]"
            />
          ) : (
            getInitials(text)
          )}
        </div>
        <Typography.Text
          ellipsis
          style={{ color: text === "Unassigned" ? "#8C8C8C" : "#000" }}
        >
          {text || "Unassigned"}
        </Typography.Text>
      </div>
    );
  };

  const normalizedValue =
    typeof value === "string" && value.trim().length > 0 ? value : undefined;

  return (
    <div
      className={compact ? "inline-block py-1" : "px-2 py-1"}
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
    >
      <Select
        value={normalizedValue}
        placeholder="Unassigned"
        allowClear
        variant="borderless"
        className={compact ? "min-w-0" : "w-full min-w-[180px]"}
        style={{ width: compact ? "fit-content" : "100%" }}
        popupMatchSelectWidth={!compact}
        options={options.map((option) => ({
          label: renderAssigneeOption(option),
          value: option,
        }))}
        onChange={(nextValue) => onChange(nextValue ?? null)}
      />
    </div>
  );
}
